module.exports = __webpack_public_path__ + "img/progress_start.2a6bf6d3.png";